type ToastSeverity = 'success' | 'error' | 'warning' | 'info';

export interface ToastEvent {
  severity: ToastSeverity;
  message: string;
  description?: string;
  autoClose?: number | false;
}

type ToastHandler = (event: ToastEvent) => void;
type ClearHandler = () => void;

const handlers = new Set<ToastHandler>();
const clearHandlers = new Set<ClearHandler>();

export const toastEventBus = {
  emit(event: ToastEvent): void {
    handlers.forEach((handler) => handler(event));
  },
  subscribe(handler: ToastHandler): void {
    handlers.add(handler);
  },
  unsubscribe(handler: ToastHandler): void {
    handlers.delete(handler);
  },
  clear(): void {
    clearHandlers.forEach((handler) => handler());
  },
  subscribeClear(handler: ClearHandler): void {
    clearHandlers.add(handler);
  },
  unsubscribeClear(handler: ClearHandler): void {
    clearHandlers.delete(handler);
  },
};
